export default function Header() {
  return (
    <header className="header">
      <h1>Sndcld Rndmzr</h1>
      <p>Long-form mixes, shuffled at random.</p>
    </header>
  )
}
